import {useState, useContext, useEffect} from "react"
import Button from "react-bootstrap/Button"
import Modal from "react-bootstrap/Modal"
import {Spinner} from "react-bootstrap"

import RefContext from "../utilities/RefContext"
import {wrappedPost, wrappedGet} from "../utilities/AxiosHelper"

const AddUnitModal = ({showModal = false, closeModal, organizationId, facilityId}) => {
    const {dispatch} = useContext(RefContext)

    const [show, setShow] = useState(false)
    const [unit, setUnit] = useState({name: "", active: true, customerKey: "", levelOfCare: 1})
    const [isLoading, setIsLoading] = useState(false)
    const [levelsOfCare, setLevelsOfCare] = useState([])

    useEffect(() => {
        fetchLevelOfCareData()
        setShow(showModal)
    }, [showModal])

    const handleClose = () => {
        setShow(false)
        closeModal()
    }

    const fetchLevelOfCareData = () => {
        wrappedGet(`levelofcare`)
            .then((response) => {
                const data = response.data

                if (!data) return

                setLevelsOfCare(data.results)
            })
            .catch((error) => {
                dispatch("showToast", {
                    show: true,
                    variant: "danger",
                    text: "Problem fetching Unit - Levels of Care",
                    timeout: 5000,
                })
            })
    }

    const handleSave = () => {
        setIsLoading(true)
        wrappedPost(`organization/${organizationId}/facility/${facilityId}/unit`, unit)
            .then((response) => {
                dispatch("showToast", {
                    show: true,
                    variant: "success",
                    text: "Unit Updated",
                    timeout: 5000,
                })
            })
            .catch((error) => {
                dispatch("showToast", {
                    show: true,
                    variant: "danger",
                    text: "Problem Saving Unit",
                    timeout: 5000,
                })
            })
            .finally(() => {
                setIsLoading(false)
                closeModal()
            })
    }

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Add New Unit</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading && (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                        <div className="d-flex align-items-center">
                            <span className="me-2">Please wait...</span>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        </div>
                    </div>
                )}

                {!isLoading && (
                    <div className="row g-8 p-8 d-flex flex-row align-items-end">
                        <div className="col">
                            <div className="row g-8 align-items-end">
                                <div className="col-12">
                                    <h3>Unit</h3>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="id-unit-name" className="form-label fw-bold">
                                        Unit Name:
                                    </label>
                                    <input
                                        id="id-unit-name"
                                        type="text"
                                        className="form-control form-control-solid ps-12"
                                        placeholder="Name"
                                        value={unit.name}
                                        onChange={(evt) => {
                                            setUnit((prev) => ({
                                                ...prev,
                                                name: evt.target.value,
                                            }))
                                        }}
                                    />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="id-unit-customer-key" className="form-label fw-bold">
                                        Customer Key:
                                    </label>
                                    <input
                                        id="id-unit-customer-key"
                                        type="text"
                                        className="form-control form-control-solid ps-12"
                                        placeholder="Key"
                                        value={unit.customerKey}
                                        onChange={(evt) => {
                                            setUnit((prev) => ({
                                                ...prev,
                                                customerKey: evt.target.value,
                                            }))
                                        }}
                                    />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="id-unit-active" className="form-label fw-bold">
                                        Active:
                                    </label>
                                    <select
                                        className="form-select form-select-solid fw-bold"
                                        id="id-unit-active"
                                        checked={unit.active}
                                        onChange={(evt) => {
                                            setUnit((prev) => ({
                                                ...prev,
                                                active: evt.target.value === "true",
                                            }))
                                        }}
                                    >
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="id-unit-leve-of-care" className="form-label fw-bold">
                                        Level of Care:
                                    </label>
                                    <select
                                        id="id-unit-leve-of-care"
                                        className="form-select form-select-solid fw-bold"
                                        value={unit.levelOfCare}
                                        onChange={(evt) => {
                                            setUnit((prev) => ({
                                                ...prev,
                                                levelOfCare: evt.target.value,
                                            }))
                                        }}
                                    >
                                        {levelsOfCare.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddUnitModal
